import React, { Component } from 'react'
import { connect } from 'react-redux'
import Badge from 'components/Badge'
import Button from 'components/Button'
import styles from './FollowableUser.css'

class FollowableUser extends Component {
  constructor(props) {
    super(props)
    this.goToProfile = this.goToProfile.bind(this)
  }
  goToProfile() {
    const { user, dispatch } = this.props
    dispatch({
      type: 'home/member/posts',
      payload: {
        username: user.username
      }
    })
  }
  render() {
    const { user, show_short_bio, className } = this.props
    if (user) {
      return (
        <div
          className={[className, styles.followable_user].join(' ')}
          onClick={this.goToProfile}
        >
          <Badge user={user} />
          {show_short_bio ? <span>{user.bio}</span> : null}
        </div>
      )
    } else {
      return null
    }
  }
}

const mapStateToProps = () => ({})
const mapDispatchToProps = dispatch => ({ dispatch })
const ConnectedFollowableUser = connect(mapStateToProps, mapDispatchToProps)(
  FollowableUser
)

export default connect(mapStateToProps, mapDispatchToProps)(FollowableUser)
